/**
 * Centralized API URL detection for the Wohnungs-Agent dashboard.
 * 
 * Logic:
 * 1. If running on localhost:3000 (React Dev Server), point to API Router on port 3001.
 * 2. If running via a Tunnel (localhost.run) or directly on port 3001, use relative path '/api'.
 * 3. Default to the environment variable or localhost:3001 as fallback.
 */

let API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

if (typeof window !== 'undefined') {
    const { hostname, port } = window.location;

    // Check if provided API URL is pointing to localhost
    const envApiUrl = process.env.REACT_APP_API_URL;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        // Local direct access (usually React Dev Server or direct Lambda port)
        if (port === '3000') {
            // React Dev Server uses the proxy in package.json
            API_URL = '/api';
        } else if (envApiUrl) {
            API_URL = envApiUrl;
        } else {
            API_URL = `http://localhost:3001/api`;
        }
    } else {
        // Tunnel (localhost.run) or Production domain
        // ALWAYS use relative path for API to ensure it stays on the same origin (including Protocol/Port)
        API_URL = '/api';
    }

    console.log(`[API Config] Hostname: ${hostname}, Detected API URL: ${API_URL}`);
}

export const API_BASE_URL = API_URL;
